"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processListParent = exports.processQuestion = exports.processListChildren = exports.updateQuestionConfig = exports.updateQuestion = void 0;
const FormQuestionControllerRegistry_1 = __importDefault(require("@opsbase/lib-form/FormQuestionController/FormQuestionControllerRegistry"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const getEnabledFormQuestionOptions_1 = __importDefault(require("@opsbase/lib-form/helpers/getEnabledFormQuestionOptions"));
const createFormQuestion_1 = __importDefault(require("@opsbase/lib-form/mutations/createFormQuestion"));
function updateQuestion(db, qId, patch = {}) {
    const q = Object.assign({}, db.questions[qId]);
    const parentList = db.lists[q === null || q === void 0 ? void 0 : q.parentListId];
    const parentListIdx = q === null || q === void 0 ? void 0 : q.parentListIdx;
    if (patch)
        Object.assign(q, patch);
    if (!parentList)
        return q;
    parentList.childQIds[parentListIdx] = q.qId;
    q.parentListIdx = parentListIdx;
    q.parentListId = parentList.lid;
    if ((patch === null || patch === void 0 ? void 0 : patch.type) || (patch === null || patch === void 0 ? void 0 : patch.config)) {
        q.answer = [];
        if (!q.config[q.type]) {
            q.config[q.type] = FormQuestionControllerRegistry_1.default[q.type].createConfig();
        }
    }
    processQuestion(db, q);
    processListParent(db, parentList);
    return q;
}
exports.updateQuestion = updateQuestion;
function updateQuestionConfig(db, qId, patch = {}) {
    const q = Object.assign({}, db.questions[qId]);
    return updateQuestion(db, qId, { config: Object.assign(Object.assign({}, q.config), { [q.type]: patch }) });
}
exports.updateQuestionConfig = updateQuestionConfig;
function processListChildren(db, sf, q) {
    var _a, _b;
    db.lists[sf.lid] = sf;
    if (q && !q.childListIds)
        q.childListIds = [];
    if (q && !((_a = q.childListIds) === null || _a === void 0 ? void 0 : _a.find(lid => lid === sf.lid)))
        q.childListIds.push(sf.lid);
    (_b = sf.childQIds) === null || _b === void 0 ? void 0 : _b.forEach((childQId, idx) => {
        const childQ = db.questions[childQId];
        childQ.parentListId = sf.lid;
        childQ.parentListIdx = idx;
        processQuestion(db, childQ);
    });
}
exports.processListChildren = processListChildren;
function processQuestion(db, q) {
    var _a, _b;
    q.childListIds = [];
    db.questions[q.qId] = q;
    if (q.type === FormQuestionType_1.default.REPETITION ||
        q.type === FormQuestionType_1.default.SECTION ||
        q.type === FormQuestionType_1.default.QUESTIONSET) {
        const lid = `${q.qId}_list_0`;
        const newQs = getChildQsForList(db, lid, (_b = (_a = q.config) === null || _a === void 0 ? void 0 : _a[q.type]) === null || _b === void 0 ? void 0 : _b.questions);
        newQs.forEach(qq => (db.questions[qq.qId] = qq));
        processListChildren(db, {
            lid,
            idx: 0,
            parentQId: q.qId,
            childQIds: newQs.map(qq => qq.qId),
        }, q);
    }
    else {
        (0, getEnabledFormQuestionOptions_1.default)(q).forEach((sf, i) => {
            var _a;
            const lid = `${q.qId}_list_${i}`;
            const newQs = getChildQsForList(db, lid, (_a = sf.subQuestions) === null || _a === void 0 ? void 0 : _a.questions);
            newQs.forEach(qq => (db.questions[qq.qId] = qq));
            processListChildren(db, {
                lid,
                idx: i,
                label: sf.label,
                labelAlt: sf.labelAlt,
                flag: sf.flag,
                parentQId: q.qId,
                childQIds: newQs.map(qq => qq.qId),
            }, q);
        });
    }
}
exports.processQuestion = processQuestion;
function processListParent(db, l, skipProcessChildren) {
    if (!l)
        return;
    if (l.parentQId) {
        const parent = Object.assign({}, db.questions[l.parentQId]);
        // Set the parent's child questions array
        const childQs = l.childQIds.map(qId => db.questions[qId]);
        if (parent.type === FormQuestionType_1.default.REPETITION ||
            parent.type === FormQuestionType_1.default.QUESTIONSET ||
            parent.type === FormQuestionType_1.default.SECTION) {
            parent.config[parent.type].questions = childQs;
        }
        else {
            const x = (0, getEnabledFormQuestionOptions_1.default)(parent)[l.idx];
            if (x)
                x.subQuestions.questions = childQs;
        }
        processListParent(db, db.lists[parent === null || parent === void 0 ? void 0 : parent.parentListId], true);
    }
    if (!skipProcessChildren)
        processListChildren(db, l);
}
exports.processListParent = processListParent;
function getChildQsForList(db, lid, qs) {
    return (qs === null || qs === void 0 ? void 0 : qs.length)
        ? qs
        : !!db.defaultSubQuestionType
            ? [(0, createFormQuestion_1.default)({ type: db.defaultSubQuestionType })]
            : [];
}
